function pushToDataLayer(data) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
}

function reset() {
  if (!!window.google_tag_manager) {
    resetDataLayer();
  } else {
    window.addEventListener("gtm_loaded", resetDataLayer);
  }
}

function resetDataLayer() {
  const tagmanagerId = window.tagmanagerId || "";
  const gtm = window.google_tag_manager[tagmanagerId];
  gtm.dataLayer.reset();
}

// Click on product in list
const selectItem = (productItem, listId = "") => {
  const listName = listId === "related_products" ? "Related products" : "";
  const data = {
    event: "select_item",
    currency: "DKK",
    value: productItem.price,
    item_list_id: listId,
    item_list_name: listName,
    items: [productItem]
  };
  pushToDataLayer(data);
};

// View product page
const viewItem = (productItem) => {
  const data = {
    event: "view_item",
    currency: "DKK",
    value: productItem.price,
    items: [productItem]
  };
  pushToDataLayer(data);
};

// Add to cart
const addToCart = (productItem, quantity = 1) => {
  const item = { ...productItem, quantity };
  const data = {
    event: "add_to_cart",
    currency: "DKK",
    value: item.price,
    items: [item]
  };
  pushToDataLayer(data);
};

// Remove from cart
const removeFromCart = (trackingData) => pushToDataLayer(trackingData);

// View cart
const viewCart = (trackingData) => {
  pushToDataLayer(trackingData);
  reset(); // Reset dataLayer to avoid appended items in remove-from-cart event
};

// Checkout step 1
const checkoutStep1 = (trackingData) => pushToDataLayer(trackingData);

// Checkout step 2
const checkoutStep2 = (trackingData) => pushToDataLayer(trackingData);

// Checkout step 3
const checkoutStep3 = (trackingData) => pushToDataLayer(trackingData);

// Checkout step 4
const checkoutStep4 = (trackingData) => pushToDataLayer(trackingData);

export default {
  selectItem,
  viewItem,
  addToCart,
  removeFromCart,
  viewCart,
  checkoutStep1,
  checkoutStep2,
  checkoutStep3,
  checkoutStep4
};
